import { call, put, takeEvery } from "redux-saga/effects"

// Ecommerce Redux States
import {
  ADD_NEW_INVOICE_HISTORY,
  // GET_INVOICE_HISTORY_DETAIL,
  GET_INVOICE_HISTORY,
  // GET_INVOICE_HISTORY_COMMENTS,
  // GET_AUTH_USER,
  // UPDATE_INVOICE_HISTORY,
  // DELETE_INVOICE_HISTORY,
} from "./actionTypes"

import {
  addInvoiceHistoryFail,
  addInvoiceHistorySuccess,
  // deleteInvoiceHistoryFail,
  // deleteInvoiceHistorySuccess,
  // getAuthUsersFail,
  // getAuthUsersSuccess,
  // getInvoiceHistoryDetailFail,
  // getInvoiceHistoryDetailSuccess,
  getInvoiceHistoryesFail,
  getInvoiceHistoryesSuccess,
  setInvoiceHistoryLoading,
  updateInvoiceHistoryFail
} from "./actions"

//Include Both Helper File with needed methods
import {
  addInvoiceHistory,
  getInvoiceHistoryes as onGetInvoiceHistoryes,
  // getInvoiceHistoryDetail,
  // getInvoiceHistoryComents as getInvoiceHistoryComentsApi, 
  // updateInvoiceHistoryes,
  // deleteInvoiceHistoryesURL
} from "helpers/fakebackend_helper"

function* fetchInvoiceHistoryes({payload}) {
  try {
    const response = yield call(onGetInvoiceHistoryes, payload)
    yield put(getInvoiceHistoryesSuccess(response))
  } catch (error) {
    yield put(getInvoiceHistoryesFail(error))
  }
}

function* addInvoiceHistoryfunc({payload}) {
  try {
    put(setInvoiceHistoryLoading())
    const response = yield call(addInvoiceHistory, payload)
    yield put(addInvoiceHistorySuccess(response))
  } catch (error) {
    yield put(addInvoiceHistoryFail(error))
  }
}


// function* fetchInvoiceHistoryDetail({ vectorId }) {
//   try {
//     const response = yield call(getInvoiceHistoryDetail, vectorId)
//     yield put(getInvoiceHistoryDetailSuccess(response))
//   } catch (error) {
//     yield put(getInvoiceHistoryDetailFail(error))
//   }
// }
// function* deleteInvoiceHistoryes(vectorId ) {
//   try {
//     const response = yield call(deleteInvoiceHistoryesURL, vectorId.payload)
//     yield put(deleteInvoiceHistorySuccess(response))
//   } catch (error) {
//     yield put(deleteInvoiceHistoryFail(error))
//   }
// }

function* invoiceHistoryesSaga() {
  yield takeEvery(GET_INVOICE_HISTORY, fetchInvoiceHistoryes)
  yield takeEvery(ADD_NEW_INVOICE_HISTORY, addInvoiceHistoryfunc)
  // yield takeEvery(UPDATE_INVOICE_HISTORY, updateInvoiceHistoryesFun)
  // yield takeEvery(DELETE_INVOICE_HISTORY,deleteInvoiceHistoryes)

}

export default invoiceHistoryesSaga
